export interface Step {
    index: number;
    label: string;
}

export const Steps = {
    YourRole: { index: 0, label: 'Your Role' },
    GetAccess: { index: 1, label: 'Get Access' },
} as const satisfies Record<string, Step>;
